import { Filter } from '../../../search/filter-bar/filters/filters';
import { SearchableFilter } from '../../../search/filter-bar/filters/searchable';
import {
  BaseFilter,
  BaseFilterSearchable,
} from '@socialchorus/shared-ui-components/dist/components/FilterBar/filters';
import { queryFilterOptionSource } from '../../../search/http';

export function convertToFilterBarFilter(filter: Filter): BaseFilter<any> {
  let fbFilter: BaseFilter<any>;
  switch (filter.behaviour) {
    case 'listable':
      fbFilter = {
        id: filter.id,
        behavior: 'select',
        label: filter.label,
        options: filter.options.map((option) => ({
          id: option.id.toString(),
          name: option.name,
        })),
        parameter: filter.parameter,
      };
      break;
    case 'selectable':
      fbFilter = {
        id: filter.id,
        behavior: 'multiselect',
        label: filter.label,
        options: filter.options.map((option) => ({
          id: option.id.toString(),
          name: option.name,
        })),
        parameter: filter.parameter,
      };
      break;
    case 'searchable':
      fbFilter = createSearchableFilter(filter);
      break;
    case 'daterangeable':
      fbFilter = {
        id: filter.id,
        behavior: 'daterange',
        label: filter.label,
        parameter: filter.parameters.join(', '),
      };
      break;
    default:
      fbFilter = {
        id: 'none',
        behavior: 'select',
        label: 'none',
        options: [],
        parameter: 'none',
      };
  }
  return fbFilter;
}

export function convertToFilterBarFilters(
  filters: Filter[]
): BaseFilter<any>[] {
  return filters.map((filter) => convertToFilterBarFilter(filter));
}

export function createSearchableFilter(
  filter: SearchableFilter
): BaseFilter<BaseFilterSearchable> {
  return {
    id: filter.id,
    behavior: 'searchable',
    label: filter.label,
    parameter: filter.parameter,
    handlePreload: async () => {
      const res = await queryFilterOptionSource('', {
        url: filter.source,
        page: 1,
        perPage: 25,
      });

      return res.data.map((opt) => {
        return opt.attributes;
      });
    },
    handleSearch: async (query: string) => {
      const res = await queryFilterOptionSource(query, {
        url: filter.source,
        page: 1,
        perPage: 25,
      });

      return res.data.map((opt) => {
        return opt.attributes;
      });
    },
    optionsLimit: 25,
  };
}
